import { useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { RichTextEditor as MantineRichText } from '@mantine/tiptap';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
}

export default function RichTextEditor({ value, onChange }: RichTextEditorProps) {
  const editor = useEditor({
    extensions: [StarterKit],
    content: value,
    onUpdate: ({ editor: ed }) => {
      onChange(ed.getHTML());
    },
  });

  if (!editor) return null;

  return (
    <MantineRichText editor={editor}>
      <MantineRichText.Toolbar sticky>
        <MantineRichText.ControlsGroup>
          <MantineRichText.Bold />
          <MantineRichText.Italic />
        </MantineRichText.ControlsGroup>
        <MantineRichText.ControlsGroup>
          <MantineRichText.H2 />
          <MantineRichText.H3 />
        </MantineRichText.ControlsGroup>
        <MantineRichText.ControlsGroup>
          <MantineRichText.BulletList />
          <MantineRichText.OrderedList />
        </MantineRichText.ControlsGroup>
      </MantineRichText.Toolbar>
      <MantineRichText.Content />
    </MantineRichText>
  );
}
